var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "search") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Search-bar",
    transform: "translate(-13.000000, -9.000000)",
    fill: "#848F9D",
    stroke: "#848F9D",
    strokeWidth: 0.4
  }, /*#__PURE__*/React.createElement("g", {
    id: "search",
    transform: "translate(14.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9,2 C5.13401,2 2,5.13401 2,9 C2,12.866 5.13401,16 9,16 C12.866,16 16,12.866 16,9 C16,5.13401 12.866,2 9,2 Z M0,9 C0,4.02944 4.02944,0 9,0 C13.9706,0 18,4.02944 18,9 C18,13.9706 13.9706,18 9,18 C4.02944,18 0,13.9706 0,9 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9428,13.9433 C14.3333,13.5528 14.9665,13.5528 15.357,13.9433 L19.707,18.2933 C20.0975,18.6838 20.0975,19.317 19.707,19.7075 C19.3165,20.098 18.6833,20.098 18.2928,19.7075 L13.9428,15.3575 C13.5523,14.967 13.5523,14.3338 13.9428,13.9433 Z",
    id: "Path"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon_search.09d40da8c502d7d06a33b110db159c1b.svg";
export { ForwardRef as ReactComponent };